<template>
  <div>
    <div class="upload-block mb-4">
      <label for="banner-img-desktop" class="upload-label"
        >Изображение (десктоп)</label
      >
      <input
        id="banner-img-desktop"
        class="upload-img-input"
        accept="image/x-png,image/jpg,image/jpeg,image/png,image/webp"
        type="file"
        @change="onFilePickedDesktop"
      />
    </div>
    <div v-if="imageDataDesktop !== ''" class="mb-4">
      <p class="mb-2 text-muted small">Десктоп:</p>
      <img :src="imageDataDesktop" alt="" class="banner-preview" />
    </div>
    <div class="upload-block mb-4">
      <label for="banner-img-mobile" class="upload-label"
        >Изображение (мобильная версия)</label
      >
      <input
        id="banner-img-mobile"
        class="upload-img-input"
        accept="image/x-png,image/jpg,image/jpeg,image/png,image/webp"
        type="file"
        @change="onFilePickedMobile"
      />
    </div>
    <div v-if="imageDataMobile !== ''" class="mb-4">
      <p class="mb-2 text-muted small">Мобильная версия:</p>
      <img :src="imageDataMobile" alt="" class="banner-preview" />
    </div>
    <div class="mb-4">
      <label>Ссылка</label>
      <va-input v-model="promoBannerLink" />
    </div>
    <div>
      <div>
        <label for="main">Начальная (стартовая) страница:</label>
        <input id="main" v-model="promoBannerGroup" value="main" type="radio" />
      </div>
      <div>
        <label for="catalog">Каталог:</label>
        <input
          id="catalog"
          v-model="promoBannerGroup"
          value="catalog"
          type="radio"
        />
      </div>
    </div>
    <div class="mt-4 text-center">
      <va-button color="primary" type="button" @click="$emit('action', true)">
        Отменить
      </va-button>

      <va-button color="success" type="submit" @click="submit">
        Сохранить
      </va-button>
    </div>
  </div>
</template>

<script>
import api from "@/api/axios";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      fileDesktop: null,
      fileMobile: null,
      imageDataDesktop: "",
      imageDataMobile: "",
      promoBannerLink: "",
      promoBannerGroup: "main",
    };
  },
  methods: {
    ...mapActions({
      fetchPromoBanners: "promoBanners/getPromoBanners",
    }),
    onFilePickedDesktop(event) {
      const file = event.target.files[0];
      if (file) {
        this.fileDesktop = file;
        this.imageDataDesktop = URL.createObjectURL(file);
      }
    },
    onFilePickedMobile(event) {
      const file = event.target.files[0];
      if (file) {
        this.fileMobile = file;
        this.imageDataMobile = URL.createObjectURL(file);
      }
    },
    formatSubmitError(error) {
      if (!error.response) {
        return (
          error.message ||
          "Ошибка сети. Проверьте размер файла (до 30 МБ) и попробуйте снова."
        );
      }
      const data = error.response.data;
      if (data?.message) {
        return data.message;
      }
      if (data?.errors) {
        return Object.values(data.errors).flat().join("\n");
      }
      return `Ошибка ${error.response.status}`;
    },
    async submit() {
      if (!this.fileDesktop) {
        alert("Выберите изображение для десктопа");
        return false;
      }
      try {
        const formDataDesktop = new FormData();
        formDataDesktop.append("file", this.fileDesktop, this.fileDesktop.name);
        formDataDesktop.append("skip_optimize", "1");
        const fileDesktopInfo = await api.post("/upload-file", formDataDesktop);
        const data = {
          photo_id: fileDesktopInfo.data.id,
          group: this.promoBannerGroup,
        };
        if (this.fileMobile) {
          const formDataMobile = new FormData();
          formDataMobile.append("file", this.fileMobile, this.fileMobile.name);
          formDataMobile.append("skip_optimize", "1");
          const fileMobileInfo = await api.post("/upload-file", formDataMobile);
          data.photo_mobile_id = fileMobileInfo.data.id;
        }
        const link = this.promoBannerLink?.trim();
        if (link) {
          data.target_url = link;
        }
        await api.post("/admin/promo-banners", data);
        await this.fetchPromoBanners();
        this.$emit("action", true);
      } catch (error) {
        alert(this.formatSubmitError(error));
        return error;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-preview {
  display: block;
  max-width: 100%;
  width: 100%;
  max-height: 200px;
  object-fit: contain;
}
.text-muted {
  color: #6c757d;
}
.small {
  font-size: 0.875rem;
}
.upload-block {
  position: relative;
}
.upload-img-input {
  appearance: none;
  visibility: hidden;
}
.upload-label {
  padding: 0.375rem 1.25rem;
  background-color: rgb(44, 130, 224);
  color: #fff;
  font-weight: bold;
  border-radius: 1.5rem;
  cursor: pointer;
}
</style>
